import { getLocationsSpecificLocationsMachines } from './getLocationsSpecificLocationsMachines';

/**
 * The devices of a settings spec (`essSpec`, `sysSpec`, …) whose `flag` is
 * set, with where they sit. `specificLocation` is undefined for a zone
 * without sub-locations.
 */
export const selectedSpecDevices = (spec, flag) =>
  getLocationsSpecificLocationsMachines(Object.entries(spec ?? {}))
    .map(([location, machine, specificLocation]) => ({
      location,
      specificLocation,
      machine,
      device:
        specificLocation === undefined
          ? spec[location]?.devices?.[machine]
          : spec[location]?.subLocations?.[specificLocation]?.devices?.[
              machine
            ],
    }))
    .filter(({ device }) => device?.[flag]);
